module.exports = __webpack_public_path__ + "assets/img/banner1.c8a7c747.jpg";